import { render } from "./LeadColumnManageDrawer.vue?vue&type=template&id=6ec66aba&scoped=true"
import script from "./LeadColumnManageDrawer.vue?vue&type=script&lang=js"
export * from "./LeadColumnManageDrawer.vue?vue&type=script&lang=js"

import "./LeadColumnManageDrawer.vue?vue&type=style&index=0&id=6ec66aba&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec66aba"]])

export default __exports__